import { createSelector } from '@reduxjs/toolkit';
import { dcpcApi } from './dcpcApi';

const REGIONS_TAG = 'Regions';

dcpcApi.enhanceEndpoints({ addTagTypes: [REGIONS_TAG] });
const regionsApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({

    getRegions: builder.query({
      query: () => 'regions',
      providesTags: [REGIONS_TAG],
    }),
    getRegion: builder.query({
      query: (id) => `region/${id}`,
      providesTags: [REGIONS_TAG],
    }),
    getRegionsFGBU: builder.query({
      query: () => 'regions-fgbu',
      providesTags: [REGIONS_TAG],
    }),
    updateRegion: builder.mutation({
      query: (region) => ({
        url: `region${region.id ? `/${region.id}` : ''}`,
        method: region.id ? 'PUT' : 'POST',
        body: region,
      }),
      // async onQueryStarted(_, { dispatch, queryFulfilled }) {
      //   try {
      //     const r = await queryFulfilled;
      //     if (r.data) dispatch(updateCachedArray('getRegions', r.data));
      //   } catch (err) {
      //     console.log(err);
      //   }
      // },
      invalidatesTags: [REGIONS_TAG],
    }),

    deleteRegion: builder.mutation({
      query: (id) => ({
        url: `region/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [REGIONS_TAG],
    }),

  }),
});

export const {
  useGetRegionsQuery,
  useGetRegionQuery,
  useGetRegionsFGBUQuery,
  useUpdateRegionMutation,
  useDeleteRegionMutation,
} = regionsApi;

export const regionsSelect = (state) => regionsApi.endpoints.getRegions.select()(state);
export const regionsSelector = (state) => regionsSelect(state).data || [];

export const fgbuRegions = createSelector(
  regionsSelector,
  (regions) => regions.filter(({ vocRegionType }) => vocRegionType?.id === 1),
);

const cgmsRegionsById = createSelector(
  regionsSelector,
  (_, fgbuId) => fgbuId,
  (regions, fgbuId) => {
    if (fgbuId !== undefined) {
      return regions.filter(({ regionFGBU }) => regionFGBU?.id === fgbuId);
    }
    return regions.filter(({ vocRegionType }) => vocRegionType?.id === 2);
  },
);

export const cgmsByFgbuId = (fgbuId) => (state) => cgmsRegionsById(state, fgbuId);
